// =============================================
// COMPONENTE: LoopNode - Nó de Loop/Iteração
// =============================================
// Arquivo: LoopNode.tsx
// Descrição: Nó para executar ações repetidas (for each, while, repeat)
// =============================================

import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';
import { RefreshCw, List, Repeat } from 'lucide-react';
import ActionsBadge from './ActionsBadge';
import '../NodeStyles.css';

const LoopNode: React.FC<NodeProps> = ({ data, selected }) => {
  const {
    label,
    loopType = 'forEach',
    arrayVariable,
    itemVariable,
    condition,
    repeatCount,
    description,
    actions
  } = data;

  const getLoopIcon = () => {
    switch (loopType) {
      case 'forEach':
        return <List size={18} />;
      case 'while':
        return <RefreshCw size={18} />;
      case 'repeat':
        return <Repeat size={18} />;
      default:
        return <RefreshCw size={18} />;
    }
  };

  const getLoopLabel = () => {
    switch (loopType) {
      case 'forEach':
        return `For Each ${itemVariable || 'item'} in ${arrayVariable || 'array'}`;
      case 'while':
        return `While ${condition || 'condition'}`;
      case 'repeat':
        return `Repeat ${repeatCount || 'N'} times`;
      default:
        return 'Loop';
    }
  };

  return (
    <div className={`flow-node loop-node ${selected ? 'selected' : ''}`}>
      <Handle
        type="target"
        position={Position.Top}
        className="flow-handle"
      />

      <div className="node-header loop-header">
        {getLoopIcon()}
        <span className="node-title">{label || 'Loop'}</span>
      </div>

      <div className="node-body">
        <div className="node-detail">
          <span className="node-detail-text loop-type">
            {getLoopLabel()}
          </span>
        </div>
        {description && (
          <div className="node-description">{description}</div>
        )}
        <ActionsBadge actions={actions} />
      </div>

      <Handle
        type="source"
        position={Position.Bottom}
        id="loop-body"
        className="flow-handle"
        style={{ left: '30%' }}
      />
      <Handle
        type="source"
        position={Position.Bottom}
        id="loop-exit"
        className="flow-handle"
        style={{ left: '70%' }}
      />

      <div className="node-labels">
        <span className="handle-label" style={{ left: '20%' }}>Loop</span>
        <span className="handle-label" style={{ left: '60%' }}>Exit</span>
      </div>
    </div>
  );
};

export default LoopNode;
